module.exports = __webpack_public_path__ + "627f0c058bdb996e6d1cdfc878bea52f.png";